import { cn } from "@/shared/lib/utils"

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline" | "ghost" | "danger"
  size?: "sm" | "md" | "lg"
  children: React.ReactNode
}

export function Button({
  variant = "primary",
  size = "md",
  className,
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn(
        "font-roboto inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-all duration-200",
        "focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        {
          "bg-[#2E7D32] text-white hover:bg-[#1B5E20] hover:shadow-lg shadow-md":
            variant === "primary",
          "bg-[#1976D2] text-white hover:bg-[#0D47A1] hover:shadow-lg shadow-md":
            variant === "secondary",
          "border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 hover:border-gray-400 hover:shadow-md shadow-sm":
            variant === "outline",
          "text-gray-700 hover:bg-gray-100": variant === "ghost",
          "bg-red-600 text-white hover:bg-red-700 hover:shadow-lg shadow-md":
            variant === "danger",
        },
        {
          "px-3 py-1.5 text-sm": size === "sm",
          "px-4 py-2.5 text-sm": size === "md",
          "px-6 py-3 text-base": size === "lg",
        },
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}
